import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { AgGridColumnType, AgGridExportType, ExportedColDef, ExportedColGroupDef } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'
import { ScientificAnalysisDatasource } from '@/modules/scientific-analysis-module/components/scientific-analysis-results-panel/datasources/scientific-analysis-datasource'
import { scientificAnalysisService } from '@/modules/scientific-analysis-module/services/scientific-analysis-services'
import { Nullable } from '@/shared/types/app.types'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { InfinitePaginatorResponse } from '@/shared/resources/infinite-datasources/infinite-resource.model'
import { ScientificAnalysisEntitySubportion } from '@/modules/scientific-analysis-module/services/scientific-analysis-dto-subportion'
import { ScientificAnalysisSampleDatasource } from '@/modules/scientific-analysis-module/components/scientific-analysis-results-panel/datasources/scientific-analysis-datasource-sample'
import { ScientificAnalysisPortionDatasource } from '@/modules/scientific-analysis-module/components/scientific-analysis-results-panel/datasources/scientific-analysis-datasource-portion'
import { ScientificAnalysisCaseDatasource } from '@/modules/scientific-analysis-module/components/scientific-analysis-results-panel/datasources/scientific-analysis-datasource-case'
import { ScientificAnalysisPatientDatasource } from '@/modules/scientific-analysis-module/components/scientific-analysis-results-panel/datasources/scientific-analysis-datasource-patient'

export class ScientificAnalysisSubportionDatasource extends ScientificAnalysisDatasource<ScientificAnalysisEntitySubportion> {
    public static getEntityGridColumns(selector: string = '', hideAll?:boolean): (ColDef | ExportedColDef | ExportedColGroupDef) {
        return {
            headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.header`),
            children: [
                {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.label`),
                    exportField: `${selector}label`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}label`,
                    sortable: false,
                    filter: false,
                    minWidth: 200,
                    flex: 1,
                    hide: hideAll ?? false
                },
                {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.type`),
                    exportField: `${selector}subportionType.sptName`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}subportionType.sptName`,
                    sortable: false,
                    filter: false,
                    minWidth: 200,
                    flex: 1,
                    hide: true
                },
                {
                    type: AgGridColumnType.DATETIME,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.requestingDate`),
                    exportField: `${selector}requestingDate`,
                    exportType: AgGridExportType.DATETIME,
                    field: `${selector}requestingDate`,
                    sortable: false,
                    filter: false,
                    minWidth: 200,
                    flex: 1,
                    hide: hideAll ?? false
                },
                {
                    type: AgGridColumnType.DATETIME,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.cuttingDate`),
                    exportField: `${selector}cuttingDate`,
                    exportType: AgGridExportType.DATETIME,
                    field: `${selector}cuttingDate`,
                    sortable: false,
                    filter: false,
                    minWidth: 200,
                    flex: 1,
                    hide: hideAll ?? false
                },
                {
                    type: AgGridColumnType.DATETIME,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.stainStartDate`),
                    exportField: `${selector}stainStartDate`,
                    exportType: AgGridExportType.DATETIME,
                    field: `${selector}stainStartDate`,
                    sortable: false,
                    filter: false,
                    minWidth: 200,
                    flex: 1,
                    hide: true
                },
                {
                    type: AgGridColumnType.DATETIME,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.stainEndDate`),
                    exportField: `${selector}stainEndDate`,
                    exportType: AgGridExportType.DATETIME,
                    field: `${selector}stainEndDate`,
                    sortable: false,
                    filter: false,
                    minWidth: 200,
                    flex: 1,
                    hide: hideAll ?? false
                },
                {
                    type: AgGridColumnType.DATETIME,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.scanStartDate`),
                    exportField: `${selector}scanStartDate`,
                    exportType: AgGridExportType.DATETIME,
                    field: `${selector}scanStartDate`,
                    sortable: false,
                    filter: false,
                    minWidth: 200,
                    flex: 1,
                    hide: true
                },
                {
                    type: AgGridColumnType.DATETIME,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.scanEndDate`),
                    exportField: `${selector}scanEndDate`,
                    exportType: AgGridExportType.DATETIME,
                    field: `${selector}scanEndDate`,
                    sortable: false,
                    filter: false,
                    minWidth: 200,
                    flex: 1,
                    hide: hideAll ?? false
                },
                {
                    type: AgGridColumnType.DATETIME,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.deliverDate`),
                    exportField: `${selector}deliverDate`,
                    exportType: AgGridExportType.DATETIME,
                    field: `${selector}deliverDate`,
                    sortable: false,
                    filter: false,
                    minWidth: 200,
                    flex: 1,
                    hide: true
                },
                {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.cuttingResponsible`),
                    exportField: `${selector}cuttingResponsible.fullName`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}cuttingResponsible.fullName`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: hideAll ?? false
                }, {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.stainStartResponsible`),
                    exportField: `${selector}stainStartResponsible.fullName`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}stainStartResponsible.fullName`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: true
                },
                {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.stainEndResponsible`),
                    exportField: `${selector}stainEndResponsible.fullName`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}stainEndResponsible.fullName`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: true
                },
                {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.cuttingDevice`),
                    exportField: `${selector}cuttingDevice.device`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}cuttingDevice.device`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: true
                },
                {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.scanStartResponsible`),
                    exportField: `${selector}scanStartResponsible.fullName`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}scanStartResponsible.fullName`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: true
                },
                {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.scanEndResponsible`),
                    exportField: `${selector}scanEndResponsible.fullName`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}scanEndResponsible.fullName`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: true
                },
                {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.deliveryResponsible`),
                    exportField: `${selector}deliveryResponsible.fullName`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}deliveryResponsible.fullName`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: true
                },
                {
                    type: AgGridColumnType.COMMON_SUBPORTION_STATUS,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.status`),
                    exportField: `${selector}status.name`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}status`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: hideAll ?? false
                },
                {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.assay`),
                    exportField: `${selector}assay.name`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}assay.name`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: hideAll ?? false
                },
                {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.protocol`),
                    exportField: `${selector}protocol.prtName`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}protocol.prtName`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: hideAll ?? false
                }, {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.assayGroup`),
                    exportField: `${selector}assayGroup.name`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}assayGroup.name`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: hideAll ?? false
                }, {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.descriptionURV`),
                    exportField: `${selector}valuableConceptURV.description`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}valuableConceptURV.description`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: true
                },
                {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.URV`),
                    exportField: `${selector}valuableConceptURV.totalValue`,
                    exportType: AgGridExportType.FLOAT,
                    field: `${selector}valuableConceptURV.totalValue`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: true
                },
                {
                    type: AgGridColumnType.PRIORITY,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.priority`),
                    exportField: `${selector}priority.name`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}priority.level`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    hide: true
                },
                {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.requestResponsible`),
                    exportField: `${selector}requestResponsible.fullName`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}requestResponsible.fullName`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: hideAll ?? false
                },
                {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.observations`),
                    exportField: `${selector}observations`,
                    exportType: AgGridExportType.TEXT,
                    field: `${selector}observations`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: true
                },
                {
                    type: AgGridColumnType.CHECK_ICON,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.hasRevision`),
                    exportField: `${selector}hasRevision`,
                    exportType: AgGridExportType.BOOLEAN,
                    field: `${selector}hasRevision`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: true
                },
                {
                    type: AgGridColumnType.CHECK_ICON,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.hasIncidents`),
                    exportField: `${selector}hasIncidents`,
                    exportType: AgGridExportType.BOOLEAN,
                    field: `${selector}hasIncidents`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: true
                },
                {
                    type: AgGridColumnType.CHECK_ICON,
                    headerName: i18n.tc(`scientificAnalysis.grid.results.subportion.hasAttachments`),
                    exportField: `${selector}hasAttachments`,
                    exportType: AgGridExportType.BOOLEAN,
                    field: `${selector}hasAttachments`,
                    sortable: false,
                    filter: false,
                    flex: 1,
                    minWidth: 200,
                    hide: true
                }
            ]

        }
    }

    public getGridColumns(): (ColDef | ExportedColDef | ExportedColGroupDef)[] {
        return [
            { type: AgGridColumnType.CUSTOM_CHECKBOX },
            ScientificAnalysisSubportionDatasource.getEntityGridColumns(),
            ScientificAnalysisPortionDatasource.getEntityGridColumns('portion.', true),
            ScientificAnalysisSampleDatasource.getEntityGridColumns('portion.sample.', true),
            ScientificAnalysisCaseDatasource.getEntityGridColumns('portion.sample.caseStudy.', true),
            ScientificAnalysisPatientDatasource.getEntityGridColumns('portion.sample.caseStudy.patient.', true)
        ]
    }

    public async paginator(_filterModel: CommonFilterModel, params: CommonParams, scrollId: string, totalElements: number): Promise<InfinitePaginatorResponse<ScientificAnalysisEntitySubportion>> {
        const response: InfinitePaginatorResponse<ScientificAnalysisEntitySubportion> = await scientificAnalysisService.search(this.scientificAnalysis, params, scrollId, totalElements) as InfinitePaginatorResponse<ScientificAnalysisEntitySubportion>
        this.setTotalElements(response.scrollPage.totalElements)
        return {
            content: response.content,
            scrollPage: {
                scrollId: encodeURIComponent(JSON.stringify(response?.scrollPage?.scrollId)),
                size: response.scrollPage.size,
                totalElements: response.scrollPage.totalElements
            }
        }
    }

    public getPatAndLabId(selectedRow: ScientificAnalysisEntitySubportion): [number, number] {
        return [selectedRow.portion.sample.caseStudy.patient.id, selectedRow.portion.sample.caseStudy.laboratoryId]
    }

    public getLabAndCaseId(selectedRow: ScientificAnalysisEntitySubportion): [number, Nullable<number>] {
        return [selectedRow.portion.sample.caseStudy.laboratoryId, selectedRow.portion.sample.caseStudy.id]
    }

    public getHTMLFieldsList(data: ScientificAnalysisEntitySubportion): string[] {
        return []
    }
}
